import type { MarketVariants } from '@/lib/i18n'

export type Slide4TwoStagesCopy = {
  eyebrow: string
  title: string
  step1Title: string
  step1Body: string
  step2Title: string
  step2Body: string
  step3Title: string
  step3Body: string
}

export const copy: MarketVariants<Slide4TwoStagesCopy> = {
  US: {
    eyebrow: 'The scammer’s playbook',
    title: 'Different scams, same pattern',
    step1Title: 'Gain trust',
    step1Body:
      'Borrow credibility from a name, brand, or relationship you already trust.',
    step2Title: 'Trigger emotion',
    step2Body:
      'Make you feel something strong enough to stop you from questioning it.',
    step3Title: 'Push action',
    step3Body:
      'Get you to click, pay, share, or download before your critical thinking catches up.',
  },
  ar: {
    eyebrow: 'خطة المحتال',
    title: 'عمليات احتيال مختلفة، والنمط نفسه',
    step1Title: 'كسب الثقة',
    step1Body:
      'استعارة المصداقية من اسم أو علامة تجارية أو علاقة تثق بها أصلاً.',
    step2Title: 'إثارة المشاعر',
    step2Body:
      'جعلك تشعر بشيء قوي بما يكفي ليمنعك من التشكيك في الأمر.',
    step3Title: 'الدفع إلى التصرف',
    step3Body:
      'دفعك إلى النقر أو الدفع أو المشاركة أو التنزيل قبل أن يلحق بك تفكيرك النقدي.',
  },
}
